import {config} from "../../../helpers/config";


export const methods = {
  convertGroupType(code, reasons) {
    let data = config().section[code];
    if (data) {
      return data.name;
    }
    if (code.startsWith("EXTERNAL_")) {
      let numCode = code.split("EXTERNAL_")[1]
      let reason = reasons[numCode];
      if (reason) {
        return reason.name;
      }
    }
    if (code === "REPAYMENT_CREDIT") {
      return 'Принять деньги'
    }
    if (code === "REPAYMENT_DEBIT") {
      return 'Выдать деньги'
    }
    if (code === 'REFUND_REALISED_THING') {
      return 'Возврат невостребованного имущества'
    }
    return undefined
  },
  isRevertable(section) {
    return section.startsWith("EXTERNAL_");
  }
}